<template>
  <div class="justify-between gap-2 mb-5" :class="layoutClasses">
    <div
      class="flex capitalize items-center cursor-pointer text-sm font-bold opacity-75"
      v-for="c in coverages.coverages"
      :key="c.id"
      @click="showCoveragesDetails"
    >
      <a-tooltip placement="top">
        <template slot="title">
          <div class="flex flex-col items-center cursor-pointer" @click="showCoveragesDetails">
            <span v-if="c.description && c.description.length > 0" class="mb-2">
              {{ c.description }}
            </span>
            <span class="opacity-50 text-sm">Clicca per maggiori dettagli</span>
          </div>
        </template>
        <a-icon type="check" class="mr-1" :style="{ color: '#ED8936' }" />
        {{ c.label }}
      </a-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCoverages',

  props: {
    coverages: {
      type: Object,
    },
    layout: {
      type: String,
      default: 'grid-2',
    },
  },

  methods: {
    showCoveragesDetails(e) {
      e.preventDefault();
      window.open(this.coverages.link, '_blank');
    },
  },

  computed: {
    layoutClasses() {
      if (this.layout === 'grid-2') {
        return 'grid grid-cols-2';
      }

      if (this.layout === 'col') {
        return 'flex flex-col';
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
